import { Navigate, useParams } from "react-router";
import useClientContext from "../../../context/useClientContext";
import { pageRoutes } from "../../../routes";
import ObjectDetailsPage from "../../entityFields/ObjectDetailsPage";
import { checklistsPageTabs } from "../checklists/checklistsPageTabs";

const TaskTemplateDetailsPage = () => {
  const { id } = useParams();
  const { clientCode } = useClientContext();
  const backButtonPath = `/${clientCode}/${pageRoutes.workflows}/${pageRoutes.checklists}?tab=${checklistsPageTabs.taskTemplates}`;

  if (!id) {
    return <Navigate to={backButtonPath} />;
  }

  return <ObjectDetailsPage objectId={id} objectType="ChecklistTaskTemplate" backButtonPath={backButtonPath} />;
};

export default TaskTemplateDetailsPage;
